import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import { AsIs, DisclosureBox, HasDisclosures, InStock, QandA } from './Styles';

const propTypes = {
  testId: PropTypes.string.isRequired,
  isAsIs: PropTypes.bool.isRequired,
  hasDisclosures: PropTypes.bool.isRequired,
  isLanded: PropTypes.bool.isRequired,
  showQnAIcon: PropTypes.bool
};

const defaultProps = {
  showQnAIcon: false
};

const TradeDisclosures = ({
  testId,
  isAsIs,
  hasDisclosures,
  isLanded,
  showQnAIcon
}) => {
  return (
    <DisclosureBox testId={`${testId}-body`}>
      {isAsIs && (
        <div className="vdp-asis">
          <AsIs testId={`${testId}-as-is`}>
            <FormattedMessage id="vdp.asis" />
          </AsIs>
        </div>
      )}
      {hasDisclosures && (
        <HasDisclosures testId={`${testId}-has-disclosures`}>
          <FormattedMessage id="badges.hasDisclosures" />
        </HasDisclosures>
      )}
      {isLanded && (
        <InStock testId={`${testId}-in-stock`}>
          <FormattedMessage id="badges.inStock" />
        </InStock>
      )}
      {showQnAIcon && (
        <QandA testId={`${testId}-q-and-a`}>
          <FormattedMessage id="badges.QA" />
        </QandA>
      )}
    </DisclosureBox>
  );
};

TradeDisclosures.propTypes = propTypes;
TradeDisclosures.defaultProps = defaultProps;

export default TradeDisclosures;
